import { PGPaymentLinks } from "./../../../../../Integrations"
import { useOutletContext } from "react-router"

export default function PGIntegrationItemPaymentLinks() {
	const context = useOutletContext<{ appId: number }>()
	return <PGPaymentLinks appId={context.appId} />
}
